import { createValidation } from '../../utils/validation';
import distributorConfig from './distributorConfig';

// Create validation factory for Distributor entity
const createDistributorValidation = () => {
  return createValidation(distributorConfig.fields);
};

// Export both the factory and a default instance
export const validateDistributorData = createDistributorValidation();
export const createDistributorValidationSchema = createDistributorValidation;
export default createDistributorValidation;

